import { left } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import { UpdateDashboardAccessClient } from 'use-case/dashboard/update/updateDashboardClient';
import { DashboardUserGroup } from 'domain/entity/dashboard';
import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { UpdateDashboardAccessCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardAccessCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardAccessClient => (
    criteria: UpdateDashboardAccessCriteria
) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}`, {
        method: 'PATCH',
        body: JSON.stringify(asDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));

export const asDashboardJson = (criteria: UpdateDashboardAccessCriteria): DashboardUpdateAccessJsonRequest => ({
    access: {
        visibility: criteria.access.visibility,
        groups: criteria.access.groups.map(
            (group: DashboardUserGroup): UserGroupJsonRequest => ({
                level: group.level,
                id: group.id,
            })
        ),
    },
});

export type DashboardUpdateAccessJsonRequest = {
    access: { visibility: string; groups: UserGroupJsonRequest[] };
};

type UserGroupJsonRequest = {
    id: string;
    level: string;
};
